module.exports = __webpack_public_path__ + "static/img/chanping15.1007891.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/yszq/chanping15.jpg
// module id = JaPz
// module chunks = 0